export default {
    computed: {
        currentPost() {
            return {}
        },
        user() {
            if (this.$store.getters['auth/user']) {
                const {
                    userId,
                    nick,
                    avatarUrl,
                    email,
                    role,
                    firstName,
                    lastName
                } = this.$store.getters['auth/user']

                return {
                    userId,
                    nick,
                    avatar: avatarUrl,
                    email,
                    role,
                    firstName,
                    lastName
                }
            }

            return null;
        },
        commentOptions() {
            return {
                postTitle: this.currentPost.title,
                postType: this.currentPost.postType,
                postSlug: this.currentPost.slug,
                rubric: this.currentPost.rubric,
                genre: this.currentPost.genre,
                category: this.currentPost.category,
                articleType: this.currentPost.articleType,
            }
        },
        commentTags() {
            return this.currentPost.tags
        },
    }
}
